export default {
  isLoading: (state) => state.isLoading,
  rules: (state) => state.rules,
  frequencies: (state) => state.frequencies,
  tickets: (state) => state.tickets,
};
